import {REQUEST_NSIS} from '../../../const';

export default function NSISReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_NSIS:
        return action.num_of_sis;
    default:
      return state;
  }
}